import {createContext} from "react";


const OrganizationContext = createContext({
    organization:"no org",
    setOrganization:()=>{}
});
export default OrganizationContext;